/* eslint-disable class-methods-use-this */
// 运行时订阅者队列
var subscribers = {};
var nextId = 0;
var EventBus = /** @class */ (function () {
    function EventBus() {
    }
    EventBus.getInstance = function () {
        if (this.instance === undefined) {
            this.instance = new EventBus();
        }
        return this.instance;
    };
    EventBus.prototype.emit = function (event, arg) {
        var subscriber = subscribers[event];
        if (subscriber === undefined)
            return;
        Object.keys(subscriber).forEach(function (key) { return subscriber[key](arg); });
    };
    EventBus.prototype.on = function (event, callback) {
        var id = this.getNextId();
        if (!subscribers[event])
            subscribers[event] = {};
        subscribers[event][id] = callback;
        return {
            unregister: function () {
                delete subscribers[event][id];
                if (Object.keys(subscribers[event]).length === 0)
                    delete subscribers[event];
            }
        };
    };
    EventBus.prototype.getNextId = function () {
        return nextId += 1;
    };
    EventBus.instance = undefined;
    return EventBus;
}());
export { EventBus };
export var eventBus = EventBus.getInstance();
//# sourceMappingURL=eventBus.js.map